// @redux-policy: transient-display-cache
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  companyId: null,
  kycCompanyName: '',
  kycStreetAddress: '',
  kycCity: '',
  kycStateProvince: '',
  kycPostalCode: '',
  kycCountry: '',
  kycAnnualTurnover: '',
  kycRegistrationNumber: '',
  kycIdentificationDocument: null,
  kycProofOfAddress: null,
  kycFinancialStatements: null,
  kycStatus: 'incomplete',
  industry: '',
  goodsAndServices: '',
  details: '',
  contacts: [],
};

const customerKYCSlice = createSlice({
  name: 'customerKYC',
  initialState,
  reducers: {
    resetCustomerKYC: () => {
      return { ...initialState, companyId: null };
    },
    setCustomerKYC: (state, action) => {
      return { ...state, ...action.payload };
    },
    setAddress: (state, action) => {
      const { street, city, state: stateProvince, postalCode, country } = action.payload;
      state.kycStreetAddress = street;
      state.kycCity = city;
      state.kycStateProvince = stateProvince;
      state.kycPostalCode = postalCode;
      state.kycCountry = country;
    },
    addContact: (state) => {
      state.contacts.push({ firstName: '', lastName: '', mobilePhone: '', email: '', function: '' });
    },
    removeContact: (state, action) => {
      state.contacts.splice(action.payload, 1);
    },
    updateContact: (state, action) => {
      const { index, contact } = action.payload;
      state.contacts[index] = contact;
    },
    setCompanyId: (state, action) => {
      state.companyId = action.payload || null;
    },
  },
});

export const { resetCustomerKYC, setCustomerKYC, setAddress, addContact, removeContact, updateContact, setCompanyId } = customerKYCSlice.actions;
export const selectCustomerKYC = (state) => state.customerKYC; // Selector added here
export default customerKYCSlice.reducer;
